import { uniqBy } from 'lodash';
import { orderBy } from 'lodash/collection';
import { isEmpty } from 'lodash/lang';

import { UNASSIGNED_ASSIGNEE } from 'components/pages/patient-source/TaskWorklist/constants';

export function getIds(collection) {
  return !isEmpty(collection) ? collection.map(e => e.id) : null;
}

export function toSsuIds(studySites, selectedStudyMap, selectedSiteMap) {
  return studySites.reduce(function(accumulator, { id, study, site }) {
    if (selectedStudyMap[study.id] && selectedSiteMap[site.id]) {
      accumulator.push(id);
    }
    return accumulator;
  }, []);
}

export function toRequestFilters(statuses, topics, assignee, ssuIds) {
  return {
    assigneeIds: getIds(assignee.value),
    taskStatuses: getIds(statuses.value),
    taskTopics: getIds(topics.value),
    ssuIds
  };
}

export function prepareAssignees(list) {
  return [
    ...orderBy(
      list.map(item => ({
        name: `${item.lastName} ${item.firstName}`,
        id: item.personnelIdentifier,
        roles: item.roles
      })),
      ['name'],
      'asc'
    ),
    UNASSIGNED_ASSIGNEE
  ];
}

export function createSelectedMap(list) {
  return list.reduce((acc, curr) => {
    acc[curr.id] = true;
    return acc;
  }, {});
}

export function getUniqueSitesFromStudySites(studySites) {
  const sites = studySites.map(s => s.site);
  return orderBy(uniqBy(sites, 'id'), 'name', 'asc');
}
